// src/components/Item/ItemList.js
import React from "react";
import ItemItem from "./ItemItem";
import styles from "./ItemList.module.css";

const ItemList = ({
  items,
  onDelete,
  deleteConfirmMessage,
  onEdit,
  onCountSave,
  onHistoryClick,
  isSuperAdmin,
  onDistributionClick,
  emptyText = "Stok bulunamadı",
}) => (
  <div className={styles.itemList}>
    {items && items.length > 0 ? (
      <div className={styles.table}>
        <div className={styles.header}>
          <div className={styles.cell}>İsim</div>
          <div className={styles.cell}>Kategori</div>
          <div className={styles.cell}>Miktar</div>
          <div className={styles.cell}>Son Güncelleme</div>
          <div className={styles.cell}>İşlemler</div>
        </div>
        {items.map((item) => (
          <ItemItem
            key={item.assignedItemId || item._id}
            item={item}
            onDelete={onDelete}
            deleteConfirmMessage={deleteConfirmMessage}
            onEdit={onEdit}
            onCountSave={onCountSave}
            onHistoryClick={onHistoryClick}
            isSuperAdmin={isSuperAdmin}
            onDistributionClick={onDistributionClick}
          />
        ))}
      </div>
    ) : (
      <p>{emptyText}</p>
    )}
  </div>
);

export default ItemList;
